
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'customer-portal-app',
  currentProjectVersion: 'static-1.3035',
  depVersions: {
  "customer-portal-app": "static-1.3035",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.494",
  "data-fetching-client": "static-1.9918",
  "emoji-mart": "static-3.4",
  "enviro": "static-4.455",
  "growth-payments-core": "static-1.26102",
  "head-dlb": "static-1.5007",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5855",
  "hs-test-utils": "static-1.8289",
  "hub-http": "static-1.6473",
  "hub-http-shared-msw-handlers": "static-1.10550",
  "hubspot-dlb": "static-2.1882",
  "hubspot-prosemirror": "static-1.18896",
  "hubspot-url-utils": "static-1.4297",
  "HubStyleTokens": "static-2.11744",
  "I18n": "static-7.1665",
  "immutable": "static-2.83",
  "jasmine-runner": "static-1.6711",
  "payment-link-components": "static-1.24098",
  "portals-platform-bend-plugin": "static-1.19",
  "prosemirror": "static-1.13",
  "quartz": "static-1.7395",
  "quartz-core": "static-1.6614",
  "quartz-i18n": "static-1.1070",
  "react": "static-7.191",
  "react-colorpicker": "static-2.10468",
  "react-dlb": "static-1.86",
  "react-utils": "static-2.5528",
  "reselect": "static-3.9",
  "rich-text-lib": "static-1.20252",
  "transmute": "static-2.85",
  "ui-addon-upgrades": "static-9.18333",
  "ui-components-test-utils": "static-1.5881",
  "UIComponents": "static-3.8690",
  "foundations-assets": "static-1.5144",
  "foundations-components": "static-1.8418",
  "foundations-theming": "static-1.4727",
  "foundations-theming-specialty": "static-1.2443",
  "framer-motion": "static-1.76",
  "metrics-js": "static-1.9867",
  "PortalIdParser": "static-2.404",
  "portals-platform-lib": "static-1.1370",
  "quartz-config": "static-1.1173",
  "quartz-routing": "static-1.825",
  "quick-fetch": "static-1.4104",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-dom": "static-7.85",
  "react-rhumb": "static-1.16972",
  "rpc-client-utils": "static-1.4923",
  "sanitize-text": "static-1.8412",
  "styled-components": "static-2.95",
  "tanstack-table": "static-1.59",
  "ui-addon-draggable": "static-3.5016",
  "ui-addon-react-router-dom": "static-1.9797",
  "usage-tracker": "static-1.7617",
  "usage-tracker-anonymous": "static-1.6034",
  "usage-tracker-core": "static-1.7467",
  "video-components-external": "static-1.12086",
  "apollo-stack-hubspot": "static-3.84",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "react-redux": "static-7.75",
  "redux": "static-4.76",
  "bend-plugin-trellis-migration": "static-1.3591",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3672",
  "quartz-webpack": "static-1.3619",
  "bend-plugin-quartz-routing": "static-1.473",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.86",
  "customer-data-objects": "static-1.7948",
  "frontend-preferences-client": "static-1.8187",
  "laboratory-lib": "static-3.7413",
  "onboarding-scopes": "static-1.6715",
  "seat-types-lib": "static-1.654",
  "ui-addon-opt": "static-4.8626",
  "HeadJS": "static-2.791",
  "hs-test-utils-bend-plugin": "static-1.3400",
  "msw": "static-1.39",
  "testing-library": "static-1.156",
  "hs-locale-management": "static-1.265",
  "ts-schema": "static-1.4266",
  "webpack-env": "static-1.54",
  "content-assistance-lib": "static-1.8148",
  "content-media-capture": "static-1.5344",
  "cssUtils": "static-1.876",
  "customer-data-ui-utilities": "static-1.10088",
  "file-manager-components": "static-1.24395",
  "HubStyle": "static-2.12051",
  "knowledge-content-types": "static-1.8628",
  "PatternValidationJS": "static-1.3158",
  "react-input-autosize": "static-2.17",
  "StyleGuideUI": "static-3.497",
  "ui-addon-emoji-picker": "static-1.10146",
  "ui-addon-i18n": "static-1.11404",
  "ui-business-units-lib": "static-1.9344",
  "ui-shepherd-react": "static-3.10525",
  "video-data-lib": "static-1.35744",
  "i18n-data": "static-1.228",
  "moment-timezone": "static-5.87",
  "jasmine": "static-4.4577",
  "commerce-tours-lib": "static-1.6555",
  "customer-data-properties": "static-1.52472",
  "getting-started-shared-tasks": "static-1.19145",
  "growth-onboarding-reliability": "static-1.5341",
  "onboarding-tours": "static-1.17061",
  "reference-resolvers-lite": "static-1.8361",
  "sales-checkout-service-client": "static-1.3789",
  "ui-addon-iframeable": "static-1.9335",
  "user-context": "static-1.5377",
  "bender-build-tools": "static-1.3397",
  "dispatcher": "static-1.142",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.871",
  "hubspotter-http": "static-1.4836",
  "icons": "static-2.675",
  "mobile-manifest-mixins": "static-1.569",
  "module-federation": "static-1.30",
  "opentelemetry-fe": "static-1.405",
  "quartz-auth": "static-1.1070",
  "quartz-head": "static-1.1060",
  "quartz-test": "static-1.1070",
  "quartz-tracking": "static-1.774",
  "trellis-components": "static-1.2537",
  "ui-fonts": "static-1.1006",
  "usage-tracker-container": "static-1.7607",
  "csstype": "static-1.50",
  "hs-story-utils": "static-1.9687",
  "data-token-picker": "static-1.16834",
  "FileManagerLib": "static-1.40035",
  "property-translator": "static-1.5657",
  "atom": "static-1.5346",
  "merchandise-lib": "static-1.274",
  "purchase-motions-components": "static-1.6299",
  "salesImages": "static-1.532",
  "SharedI18nStrings": "static-1.182",
  "foundations-components-test-utils": "static-1.5901",
  "react-create-root-preference": "static-1.64",
  "react-select-plus": "static-1.109",
  "react-virtualized": "static-2.104",
  "ui-images": "static-2.1233",
  "bend-plugin-foundations-components": "static-1.4687",
  "floating-ui": "static-1.62",
  "react-aria": "static-1.70",
  "trellis-assets": "static-1.2518",
  "bend-plugin-foundations-theming": "static-1.3210",
  "foundations-theming-base": "static-1.3712",
  "stylex": "static-1.38",
  "interframe": "static-3.5016",
  "js-cookie": "static-1.18",
  "usage-tracker-multi": "static-1.6031",
  "opentelemetry-fe-types": "static-1.30",
  "web-vitals": "static-1.11",
  "bend-plugin-chirp-manifest": "static-1.333",
  "chirp-fetch": "static-1.2154",
  "autolinker": "static-3.11",
  "sanitize": "static-1.4736",
  "react-flip-move": "static-1.75",
  "apollo-link-hub-http": "static-2.4916",
  "content-media-composition-data-lib": "static-1.13148",
  "content-media-compositions": "static-2.17155",
  "idb-keyval": "static-1.48",
  "immer": "static-1.94",
  "immerable": "static-1.4412",
  "magpie-lib": "static-1.5727",
  "magpie-types": "static-1.5187",
  "media-bridge-lib": "static-1.19352",
  "inbound-db-properties-service-client": "static-1.4030",
  "superstore": "static-1.5016",
  "feedback-loader": "static-1.29753",
  "ai-components-ui-library": "static-1.9627",
  "ui-addon-video-player": "static-1.8964",
  "ui-coaching-tips": "static-1.29240",
  "ContentUtils": "static-1.69063",
  "fix-webm-duration": "static-1.27",
  "notification-sounds": "static-1.4686",
  "sassPrefix": "static-1.163",
  "react-dnd-compat": "static-1.4876",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "breeze-engine-lib": "static-1.1606",
  "copilot-toolkit": "static-1.11774",
  "avatar-components": "static-1.2755",
  "navigation-messaging": "static-1.8065",
  "redux-thunk": "static-2.77",
  "reference-resolvers": "static-1.8440",
  "commerce-products-lib": "static-1.10443",
  "crm-message-bus": "static-1.43670",
  "growth-data-modal": "static-1.5837",
  "hubspot-apollo-client": "static-1.5139",
  "onboarding-tours-client": "static-1.5275",
  "batch-promise": "static-1.1801",
  "calling-global-api": "static-1.65432",
  "calling-internal-common": "static-1.31579",
  "calling-lifecycle-internal": "static-1.66814",
  "calling-lifecycle-messages": "static-1.59108",
  "conditional-properties-service-client": "static-1.3986",
  "crm-index-visualization-core": "static-1.4490",
  "crm-links": "static-1.6586",
  "crm-pipelines-api-client-types": "static-1.4320",
  "customer-data-objects-ui-components": "static-1.13290",
  "customer-data-properties-shared-msw-handlers": "static-1.9877",
  "customer-data-property-utils": "static-1.8359",
  "external-options-client-types": "static-1.4313",
  "formula-editor": "static-1.14693",
  "framework-data-schema-resolvers": "static-1.7153",
  "google-libphonenumber": "static-1.42",
  "hs-resources": "static-1.451",
  "inbound-db-meta-service-client": "static-1.3718",
  "inbounddb-objects-service-types": "static-1.4397",
  "meetings-icalendar-utils-lib": "static-1.896",
  "multi-currency-client-types": "static-1.3881",
  "object-builder-ui-client": "static-1.49577",
  "pipeline-validation-client-types": "static-1.4155",
  "property-value-citations": "static-1.3086",
  "pulse": "static-1.885",
  "smart-data-capture-core": "static-1.55",
  "smart-property-lib": "static-1.8203",
  "tiered-pricing": "static-1.1892",
  "trial-components-library": "static-1.14044",
  "topics-actions-lib": "static-1.425",
  "ui-addon-form-validation": "static-1.11246",
  "zustand": "static-1.79",
  "growth-onboarding-confetti": "static-1.3323",
  "growth-onboarding-next-action-utils": "static-1.2621",
  "navigation-components": "static-1.18738",
  "onboarding-tours-utils": "static-1.1127",
  "ui-shepherd-tracker": "static-1.7906",
  "ui-universal-auth": "static-1.9320",
  "getting-started-shared-tasks-store": "static-1.18263",
  "opentelemetry-web": "static-1.11",
  "hubspotter-http-shared-msw-handlers": "static-1.10548",
  "usage-tracker-session-replay": "static-1.5303",
  "base-ui": "static-1.19",
  "react-day-picker": "static-1.7",
  "trellis-theming": "static-1.1227",
  "tanstack-virtual": "static-1.36",
  "audio-components": "static-1.6288",
  "FileManagerCore": "static-1.39894",
  "FileManagerImages": "static-1.37546",
  "video-components": "static-1.14088",
  "foundations-components-legacy": "static-1.1443",
  "purchase-motions-api": "static-1.6302",
  "signup-constants": "static-1.19538",
  "signup-ui-url-generator": "static-2.8320",
  "usage-tracker-public": "static-1.7428",
  "reactive-lib": "static-1.982",
  "simple-logging-lib": "static-1.3311",
  "chatspot-core": "static-1.22712",
  "growth-onboarding-feedback-components": "static-1.6845",
  "cms-field-types": "static-1.5075",
  "content-icons-ui": "static-1.2324",
  "integrations-lib": "static-1.16955",
  "underscore": "static-1.8",
  "breeze-engine-chat-components": "static-1.584",
  "breeze-engine-core": "static-1.884",
  "ably": "static-2.2",
  "highlight.js": "static-1.83",
  "markdown-it": "static-1.6",
  "commerce-permissions": "static-1.1037",
  "customer-data-tracking": "static-1.7142",
  "products-iframe-lib": "static-1.8520",
  "products-ui-components-shared-msw-handlers": "static-1.10932",
  "restore-request-side-panel-lib": "static-1.1589",
  "onboarding-data-sync-lib": "static-1.2437",
  "hubspot-apollo-cache": "static-1.598",
  "calling-error-reporting": "static-1.31586",
  "shared-worker-versioning": "static-1.11300",
  "calling-usage-tracker": "static-1.6799",
  "voice-sms-access-library": "static-1.1939",
  "conversations-skeleton-state": "static-1.7509",
  "crm-index-associations-lib": "static-1.6703",
  "framework-data-schema-quick-fetch": "static-1.7058",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10633",
  "redux-toolkit": "static-1.75",
  "sales-views-client-types": "static-1.4517",
  "location-customization-utils-lib": "static-1.10018",
  "bark-lib": "static-1.16767",
  "browser-prettier": "static-1.11",
  "codemirror": "static-5.99",
  "crm-properties-common-lib": "static-1.6150",
  "react-codemirror": "static-1.10899",
  "fdsr-migration-layer": "static-1.272",
  "framework-builder-read-service-client": "static-1.4194",
  "persist-promise": "static-1.3958",
  "event-emitter": "static-1.1214",
  "bend-plugin-pulse": "static-1.388",
  "fast-json-patch": "static-1.67",
  "data-agent-kit": "static-1.591",
  "fsm": "static-1.4001",
  "policy-lib": "static-1.7057",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10696",
  "embedded-academy-lib": "static-1.15405",
  "hubs-service-types": "static-1.1519",
  "growth-onboarding-next-action-components": "static-1.2649",
  "user-context-client": "static-1.4769",
  "nest": "static-1.496",
  "unified-auth-core-lib": "static-1.1116",
  "amplitude-session-replay-browser": "static-1.60",
  "breeze-artifacts-sdk": "static-1.225",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.58",
  "urlinator": "static-1.4793",
  "video-embed": "static-1.36578",
  "social-insights-client-types": "static-1.22685",
  "flux-actions": "static-1.362",
  "integrations-error-boundary-lib": "static-1.14370",
  "integrations-tracking-lib": "static-1.5868",
  "native-integrations-shared-strings": "static-1.8038",
  "redux-observable": "static-1.72",
  "ReduxMessenger": "static-2.10628",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.834",
  "InboxConnectUtils": "static-4.15483",
  "meetings-connect-utils-lib": "static-1.7870",
  "calling-orchestration-schema": "static-1.36716",
  "crm-record-cards-service-types": "static-1.3759",
  "diff-match-patch": "static-1.7",
  "react-reducer-toolkit": "static-1.16292",
  "browser-eslint": "static-2.57",
  "highcharts": "static-8.108",
  "trellis-story-utils": "static-1.4771",
  "storybook-react": "static-1.37",
  "academy-common-lib": "static-1.14865",
  "outpost": "static-1.4420",
  "universal-page-editor-lib": "static-1.3268",
  "adobe-sign-auth-lib": "static-1.380",
  "ads-unified-auth-lib": "static-1.1133",
  "google-sheets-integration-lib": "static-1.956",
  "microsoft-drive-auth-lib": "static-1.53",
  "surveymonkey-integration-lib": "static-1.400",
  "slack-ui-library": "static-1.10659",
  "hub-http-contrib": "static-1.3298",
  "ui-addon-sales-email": "static-1.5476",
  "academy-service-client": "static-1.3949",
  "croppie": "static-2.10",
  "final-form": "static-1.75",
  "SafeStorage": "static-1.4665",
  "trellis-ecosystem": "static-1.7579",
  "wootric-nps": "static-1.7172",
  "marketplace-ui-apps-core": "static-1.19164",
  "marketplace-ui-common": "static-1.20632",
  "developer-experience-shared-components": "static-1.10764",
  "immutable-less": "static-1.4911",
  "marketplace-ui-client-types": "static-1.18039",
  "ui-addon-integrations-directory-panel": "static-2.8287",
  "ui-extensibility-client-types": "static-1.4181",
  "ai-settings-ui-library": "static-1.8272",
  "nav-meta": "static-1.30375",
  "react-window": "static-1.13",
  "ui-product-approvals-common": "static-1.917",
  "apps-service-types": "static-1.4001",
  "oauth-service-types": "static-1.4507",
  "simple-data-table": "static-1.3462"
},
  depPathPrefixes: {
  "customer-portal-app": "/customer-portal-app/static-1.3035",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.494",
  "data-fetching-client": "/data-fetching-client/static-1.9918",
  "emoji-mart": "/emoji-mart/static-3.4",
  "enviro": "/enviro/static-4.455",
  "growth-payments-core": "/growth-payments-core/static-1.26102",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5855",
  "hs-test-utils": "/hs-test-utils/static-1.8289",
  "hub-http": "/hub-http/static-1.6473",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10550",
  "hubspot-dlb": "/hubspot-dlb/static-2.1882",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18896",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4297",
  "HubStyleTokens": "/HubStyleTokens/static-2.11744",
  "I18n": "/I18n/static-7.1665",
  "immutable": "/immutable/static-2.83",
  "jasmine-runner": "/jasmine-runner/static-1.6711",
  "payment-link-components": "/payment-link-components/static-1.24098",
  "portals-platform-bend-plugin": "/portals-platform-bend-plugin/static-1.19",
  "prosemirror": "/prosemirror/static-1.13",
  "quartz": "/quartz/static-1.7395",
  "quartz-core": "/quartz-core/static-1.6614",
  "quartz-i18n": "/quartz-i18n/static-1.1070",
  "react": "/react/static-7.191",
  "react-colorpicker": "/react-colorpicker/static-2.10468",
  "react-dlb": "/react-dlb/static-1.86",
  "react-utils": "/react-utils/static-2.5528",
  "reselect": "/reselect/static-3.9",
  "rich-text-lib": "/rich-text-lib/static-1.20252",
  "transmute": "/transmute/static-2.85",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18333",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5881",
  "UIComponents": "/UIComponents/static-3.8690",
  "foundations-assets": "/foundations-assets/static-1.5144",
  "foundations-components": "/foundations-components/static-1.8418",
  "foundations-theming": "/foundations-theming/static-1.4727",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2443",
  "framer-motion": "/framer-motion/static-1.76",
  "metrics-js": "/metrics-js/static-1.9867",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "portals-platform-lib": "/portals-platform-lib/static-1.1370",
  "quartz-config": "/quartz-config/static-1.1173",
  "quartz-routing": "/quartz-routing/static-1.825",
  "quick-fetch": "/quick-fetch/static-1.4104",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-dom": "/react-dom/static-7.85",
  "react-rhumb": "/react-rhumb/static-1.16972",
  "rpc-client-utils": "/rpc-client-utils/static-1.4923",
  "sanitize-text": "/sanitize-text/static-1.8412",
  "styled-components": "/styled-components/static-2.95",
  "tanstack-table": "/tanstack-table/static-1.59",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5016",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9797",
  "usage-tracker": "/usage-tracker/static-1.7617",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.6034",
  "usage-tracker-core": "/usage-tracker-core/static-1.7467",
  "video-components-external": "/video-components-external/static-1.12086",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "react-redux": "/react-redux/static-7.75",
  "redux": "/redux/static-4.76",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3591",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3672",
  "quartz-webpack": "/quartz-webpack/static-1.3619",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.473",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.86",
  "customer-data-objects": "/customer-data-objects/static-1.7948",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8187",
  "laboratory-lib": "/laboratory-lib/static-3.7413",
  "onboarding-scopes": "/onboarding-scopes/static-1.6715",
  "seat-types-lib": "/seat-types-lib/static-1.654",
  "ui-addon-opt": "/ui-addon-opt/static-4.8626",
  "HeadJS": "/HeadJS/static-2.791",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3400",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.156",
  "hs-locale-management": "/hs-locale-management/static-1.265",
  "ts-schema": "/ts-schema/static-1.4266",
  "webpack-env": "/webpack-env/static-1.54",
  "content-assistance-lib": "/content-assistance-lib/static-1.8148",
  "content-media-capture": "/content-media-capture/static-1.5344",
  "cssUtils": "/cssUtils/static-1.876",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10088",
  "file-manager-components": "/file-manager-components/static-1.24395",
  "HubStyle": "/HubStyle/static-2.12051",
  "knowledge-content-types": "/knowledge-content-types/static-1.8628",
  "PatternValidationJS": "/PatternValidationJS/static-1.3158",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "StyleGuideUI": "/StyleGuideUI/static-3.497",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10146",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11404",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9344",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10525",
  "video-data-lib": "/video-data-lib/static-1.35744",
  "i18n-data": "/i18n-data/static-1.228",
  "moment-timezone": "/moment-timezone/static-5.87",
  "jasmine": "/jasmine/static-4.4577",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6555",
  "customer-data-properties": "/customer-data-properties/static-1.52472",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19145",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5341",
  "onboarding-tours": "/onboarding-tours/static-1.17061",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8361",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3789",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9335",
  "user-context": "/user-context/static-1.5377",
  "bender-build-tools": "/bender-build-tools/static-1.3397",
  "dispatcher": "/dispatcher/static-1.142",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.871",
  "hubspotter-http": "/hubspotter-http/static-1.4836",
  "icons": "/icons/static-2.675",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.569",
  "module-federation": "/module-federation/static-1.30",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.405",
  "quartz-auth": "/quartz-auth/static-1.1070",
  "quartz-head": "/quartz-head/static-1.1060",
  "quartz-test": "/quartz-test/static-1.1070",
  "quartz-tracking": "/quartz-tracking/static-1.774",
  "trellis-components": "/trellis-components/static-1.2537",
  "ui-fonts": "/ui-fonts/static-1.1006",
  "usage-tracker-container": "/usage-tracker-container/static-1.7607",
  "csstype": "/csstype/static-1.50",
  "hs-story-utils": "/hs-story-utils/static-1.9687",
  "data-token-picker": "/data-token-picker/static-1.16834",
  "FileManagerLib": "/FileManagerLib/static-1.40035",
  "property-translator": "/property-translator/static-1.5657",
  "atom": "/atom/static-1.5346",
  "merchandise-lib": "/merchandise-lib/static-1.274",
  "purchase-motions-components": "/purchase-motions-components/static-1.6299",
  "salesImages": "/salesImages/static-1.532",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5901",
  "react-create-root-preference": "/react-create-root-preference/static-1.64",
  "react-select-plus": "/react-select-plus/static-1.109",
  "react-virtualized": "/react-virtualized/static-2.104",
  "ui-images": "/ui-images/static-2.1233",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4687",
  "floating-ui": "/floating-ui/static-1.62",
  "react-aria": "/react-aria/static-1.70",
  "trellis-assets": "/trellis-assets/static-1.2518",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3210",
  "foundations-theming-base": "/foundations-theming-base/static-1.3712",
  "stylex": "/stylex/static-1.38",
  "interframe": "/interframe/static-3.5016",
  "js-cookie": "/js-cookie/static-1.18",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.6031",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.30",
  "web-vitals": "/web-vitals/static-1.11",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.333",
  "chirp-fetch": "/chirp-fetch/static-1.2154",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.4736",
  "react-flip-move": "/react-flip-move/static-1.75",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4916",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13148",
  "content-media-compositions": "/content-media-compositions/static-2.17155",
  "idb-keyval": "/idb-keyval/static-1.48",
  "immer": "/immer/static-1.94",
  "immerable": "/immerable/static-1.4412",
  "magpie-lib": "/magpie-lib/static-1.5727",
  "magpie-types": "/magpie-types/static-1.5187",
  "media-bridge-lib": "/media-bridge-lib/static-1.19352",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4030",
  "superstore": "/superstore/static-1.5016",
  "feedback-loader": "/feedback-loader/static-1.29753",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9627",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8964",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29240",
  "ContentUtils": "/ContentUtils/static-1.69063",
  "fix-webm-duration": "/fix-webm-duration/static-1.27",
  "notification-sounds": "/notification-sounds/static-1.4686",
  "sassPrefix": "/sassPrefix/static-1.163",
  "react-dnd-compat": "/react-dnd-compat/static-1.4876",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1606",
  "copilot-toolkit": "/copilot-toolkit/static-1.11774",
  "avatar-components": "/avatar-components/static-1.2755",
  "navigation-messaging": "/navigation-messaging/static-1.8065",
  "redux-thunk": "/redux-thunk/static-2.77",
  "reference-resolvers": "/reference-resolvers/static-1.8440",
  "commerce-products-lib": "/commerce-products-lib/static-1.10443",
  "crm-message-bus": "/crm-message-bus/static-1.43670",
  "growth-data-modal": "/growth-data-modal/static-1.5837",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5139",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5275",
  "batch-promise": "/batch-promise/static-1.1801",
  "calling-global-api": "/calling-global-api/static-1.65432",
  "calling-internal-common": "/calling-internal-common/static-1.31579",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66814",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59108",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3986",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4490",
  "crm-links": "/crm-links/static-1.6586",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4320",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13290",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9877",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8359",
  "external-options-client-types": "/external-options-client-types/static-1.4313",
  "formula-editor": "/formula-editor/static-1.14693",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7153",
  "google-libphonenumber": "/google-libphonenumber/static-1.42",
  "hs-resources": "/hs-resources/static-1.451",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4397",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.896",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3881",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49577",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4155",
  "property-value-citations": "/property-value-citations/static-1.3086",
  "pulse": "/pulse/static-1.885",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.55",
  "smart-property-lib": "/smart-property-lib/static-1.8203",
  "tiered-pricing": "/tiered-pricing/static-1.1892",
  "trial-components-library": "/trial-components-library/static-1.14044",
  "topics-actions-lib": "/topics-actions-lib/static-1.425",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11246",
  "zustand": "/zustand/static-1.79",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3323",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2621",
  "navigation-components": "/navigation-components/static-1.18738",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1127",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7906",
  "ui-universal-auth": "/ui-universal-auth/static-1.9320",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18263",
  "opentelemetry-web": "/opentelemetry-web/static-1.11",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10548",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5303",
  "base-ui": "/base-ui/static-1.19",
  "react-day-picker": "/react-day-picker/static-1.7",
  "trellis-theming": "/trellis-theming/static-1.1227",
  "tanstack-virtual": "/tanstack-virtual/static-1.36",
  "audio-components": "/audio-components/static-1.6288",
  "FileManagerCore": "/FileManagerCore/static-1.39894",
  "FileManagerImages": "/FileManagerImages/static-1.37546",
  "video-components": "/video-components/static-1.14088",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1443",
  "purchase-motions-api": "/purchase-motions-api/static-1.6302",
  "signup-constants": "/signup-constants/static-1.19538",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8320",
  "usage-tracker-public": "/usage-tracker-public/static-1.7428",
  "reactive-lib": "/reactive-lib/static-1.982",
  "simple-logging-lib": "/simple-logging-lib/static-1.3311",
  "chatspot-core": "/chatspot-core/static-1.22712",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6845",
  "cms-field-types": "/cms-field-types/static-1.5075",
  "content-icons-ui": "/content-icons-ui/static-1.2324",
  "integrations-lib": "/integrations-lib/static-1.16955",
  "underscore": "/underscore/static-1.8",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.584",
  "breeze-engine-core": "/breeze-engine-core/static-1.884",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.83",
  "markdown-it": "/markdown-it/static-1.6",
  "commerce-permissions": "/commerce-permissions/static-1.1037",
  "customer-data-tracking": "/customer-data-tracking/static-1.7142",
  "products-iframe-lib": "/products-iframe-lib/static-1.8520",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10932",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1589",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2437",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.598",
  "calling-error-reporting": "/calling-error-reporting/static-1.31586",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11300",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6799",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1939",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7509",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6703",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7058",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10633",
  "redux-toolkit": "/redux-toolkit/static-1.75",
  "sales-views-client-types": "/sales-views-client-types/static-1.4517",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10018",
  "bark-lib": "/bark-lib/static-1.16767",
  "browser-prettier": "/browser-prettier/static-1.11",
  "codemirror": "/codemirror/static-5.99",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6150",
  "react-codemirror": "/react-codemirror/static-1.10899",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.272",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4194",
  "persist-promise": "/persist-promise/static-1.3958",
  "event-emitter": "/event-emitter/static-1.1214",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.388",
  "fast-json-patch": "/fast-json-patch/static-1.67",
  "data-agent-kit": "/data-agent-kit/static-1.591",
  "fsm": "/fsm/static-1.4001",
  "policy-lib": "/policy-lib/static-1.7057",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10696",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.15405",
  "hubs-service-types": "/hubs-service-types/static-1.1519",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2649",
  "user-context-client": "/user-context-client/static-1.4769",
  "nest": "/nest/static-1.496",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1116",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.225",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.58",
  "urlinator": "/urlinator/static-1.4793",
  "video-embed": "/video-embed/static-1.36578",
  "social-insights-client-types": "/social-insights-client-types/static-1.22685",
  "flux-actions": "/flux-actions/static-1.362",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14370",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5868",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8038",
  "redux-observable": "/redux-observable/static-1.72",
  "ReduxMessenger": "/ReduxMessenger/static-2.10628",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.834",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15483",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7870",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36716",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3759",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16292",
  "browser-eslint": "/browser-eslint/static-2.57",
  "highcharts": "/highcharts/static-8.108",
  "trellis-story-utils": "/trellis-story-utils/static-1.4771",
  "storybook-react": "/storybook-react/static-1.37",
  "academy-common-lib": "/academy-common-lib/static-1.14865",
  "outpost": "/outpost/static-1.4420",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3268",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.380",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1133",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.956",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.53",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.400",
  "slack-ui-library": "/slack-ui-library/static-1.10659",
  "hub-http-contrib": "/hub-http-contrib/static-1.3298",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5476",
  "academy-service-client": "/academy-service-client/static-1.3949",
  "croppie": "/croppie/static-2.10",
  "final-form": "/final-form/static-1.75",
  "SafeStorage": "/SafeStorage/static-1.4665",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7579",
  "wootric-nps": "/wootric-nps/static-1.7172",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19164",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20632",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10764",
  "immutable-less": "/immutable-less/static-1.4911",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18039",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8287",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4181",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8272",
  "nav-meta": "/nav-meta/static-1.30375",
  "react-window": "/react-window/static-1.13",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.917",
  "apps-service-types": "/apps-service-types/static-1.4001",
  "oauth-service-types": "/oauth-service-types/static-1.4507",
  "simple-data-table": "/simple-data-table/static-1.3462"
}
};
